import React from 'react';
import PropTypes from 'prop-types';
import EnergyLabel from '../EnergyLabels/EnergyLabel';


export default class PriceBreak extends React.Component {
  componentDidMount() {
    this.updateEnergyLabelLink(); // Wait for energy label doc to load in main page
  }

  getRoundedQuantity() {
    return Math.floor(this.props.quantity / this.props.packSize) * this.props.packSize;
  }

  // Wait for the documents to be rendered, then update the product info sheet link
  updateEnergyLabelLink() {
    const self = this;
    function tryUpdateLink() {
      const productInfoSheet = document.getElementById('energy-info-sheet-link');
      if (productInfoSheet) {
        self.props.energyProductInfoSheetLink = productInfoSheet.href;
        const theLink = document.getElementById('energy-label-product-information-link');
        if (theLink) {
          theLink.href = self.props.energyProductInfoSheetLink;
        }
        return true;
      }
      return false;
    }
    if (!tryUpdateLink()) { // Not there yet
      const observer = new MutationObserver(() => {
        if (tryUpdateLink()) {
          observer.disconnect();
        }
      });
      observer.observe(document, { childList: true, subtree: true });
    }
    return true;
  }

  priceBreakRender(priceBreak, index, selectedPriceBreakIndex) {
    const isRowSelected = index === selectedPriceBreakIndex;
    return (<div
      className={`table-row value-row ${isRowSelected ? 'price-range-bg' : ''}`}
      id={`value-row-${priceBreak.priceBreakRange}`}
      key={priceBreak.priceBreakRange}
    >
      <div
        className={`breakRangeWithoutUnit col-xs-${this.props.colSize}`}
      >
        {priceBreak.priceBreakRange}
      </div>
      <div className={`unitPrice col-xs-${this.props.colSize} ${this.props.isCustomerSpecificPricing ? 'customer-specific-price' : ''}`}>
        {priceBreak.priceExVat}
      </div>
      {this.props.showIndicativePrices &&
      <div className={`indicativePrice col-xs-${this.props.colSize} ${this.props.isCustomerSpecificPricing ? 'customer-specific-price' : ''}`}>
        {priceBreak.indicativePriceExVat}
      </div>
      }
    </div>
    );
  }

  render() {
    const maxCombinedPriceLength = 20;
    let selectedPriceBreakIndex = 0;
    this.props.priceBreaks.forEach((priceBreak, index) => {
      if ((this.getRoundedQuantity() >= priceBreak.priceBreakLowerBound ||
        (this.getRoundedQuantity() < priceBreak.priceBreakLowerBound && index === 0)) &&
      (this.getRoundedQuantity() <= priceBreak.priceBreakUpperBound || !priceBreak.priceBreakUpperBound)) {
        selectedPriceBreakIndex = index;
      }
    });
    const willPricesOverlap = (this.props.productPrice.currencySymbol +
      this.props.priceBreaks[selectedPriceBreakIndex].priceExVatWithoutCurrencySymbol.toString() +
      this.props.productPrice.currencySymbol +
      this.props.priceBreaks[selectedPriceBreakIndex].priceIncVatWithoutCurrencySymbol.toString()).length > maxCombinedPriceLength;

    return (
      <div>
        <div className="topPriceArea">
          <div className="txt">{this.props.labels.linePriceHeaderLabel}</div>
          {
            this.props.productPrice.wasPrice && !this.props.isCustomerSpecificPricing &&
            <div className="was-price">{this.props.labels.wasPriceLabel}
              <span>{this.props.productPrice.wasPrice}</span>
            </div>
          }
          {
            this.props.priceBreaks[selectedPriceBreakIndex].wasPriceExVat && this.props.isCustomerSpecificPricing &&
            <div className="was-price-csp">
              <span className="was-price-csp-label">{this.props.labels.wasPriceLabel}</span>
              <span className="was-price-csp-text">{this.props.priceBreaks[selectedPriceBreakIndex].wasPriceExVat}</span>
            </div>
          }
          <div className="current-price">
            <div className={` ${willPricesOverlap ? 'product-price-newline' : 'product-price'}`}>
              {this.props.isCustomerSpecificPricing && <span className="you-pay">{this.props.labels.youPayLabel}</span>}
              {this.props.productPrice.currencySymDisplayFirst &&
              <span
                className={`priceCurrency ${this.props.isCustomerSpecificPricing ? 'customer-specific-price' : ''}`}
              >{this.props.productPrice.currencySymbol}</span>}
              <span
                className={`price ${this.props.isCustomerSpecificPricing ? 'customer-specific-price' : ''}`}
                content={this.props.productPrice.currencyCode}
              >{this.props.priceBreaks[selectedPriceBreakIndex].priceExVatWithoutCurrencySymbol.toString()}
              </span>
              {!this.props.productPrice.currencySymDisplayFirst &&
              <span
                className={`priceCurrency ${this.props.isCustomerSpecificPricing ? 'customer-specific-price' : ''}`}
              >{this.props.productPrice.currencySymbol}
              </span>}
              <div className="vat">{this.props.labels.exVatLabel}</div>
            </div>
            {!this.props.priceBreaks[selectedPriceBreakIndex].incVatAndExVatPriceSameFlag &&
            <div className={` ${willPricesOverlap ? 'product-price-vat-newline' : 'product-price-vat'}`}>
              {this.props.productPrice.currencySymDisplayFirst &&
              <span className="priceCurrency txt-vat">{this.props.productPrice.currencySymbol}</span>}
              <span
                className="price txt-vat"
                content={this.props.productPrice.currencyCode}
              >{this.props.priceBreaks[selectedPriceBreakIndex].priceIncVatWithoutCurrencySymbol.toString()}</span>
              {!this.props.productPrice.currencySymDisplayFirst &&
              <span className="priceCurrency txt-vat">{this.props.productPrice.currencySymbol}</span>}
              <div className="vat txt-vat">{this.props.labels.vatLabel}</div>
            </div>}
          </div>
        </div>
        {
          (this.props.energyEfficiencyRating && this.props.energyEfficiencyRating.trim() !== '') &&
          <div className="energy-rating other-contents">
            <EnergyLabel
              src={this.props.energyEfficiencyRating}
              alt={this.props.energyEfficiencyRatingText}
              labelImageLink={this.props.energyEfficiencyImage}
              title={this.props.labels.energyLabelsTitle}
              closeText={this.props.labels.energyLabelsCloseButton}
            />
            <a href={this.props.energyProductInfoSheetLink} target="_blank" rel="noopener noreferrer" id="energy-label-product-information-link" className="product-page-energy-label">
              <u>{this.props.labels.energyLabelsProductInformationSheet}</u>
            </a>
          </div>
        }
        <div className="price-table" id="break-prices-list">
          <div id="column-row" className="table-row">
            <div className={`breakRangeWithoutUnit col-xs-${this.props.colSize}`}>{this.props.labels.rangeHeaderLabel}</div>
            <div
              className={`unitPrice col-xs-${this.props.colSize} ${this.props.isCustomerSpecificPricing ? 'customer-specific-price' : ''}`}
            >{this.props.labels.priceHeaderLabel}</div>
            {
              this.props.showIndicativePrices &&
              <div
                className={`indicativePrice col-xs-${this.props.colSize} ${this.props.isCustomerSpecificPricing ? 'customer-specific-price' : ''}`}
              >{this.props.labels.indicativePriceHeaderLabel}
              </div>
            }
          </div>
          {
            this.props.priceBreaks.map((priceBreak, index) =>
              this.priceBreakRender(priceBreak, index, selectedPriceBreakIndex))
          }
          {this.props.showIndicativePrices &&
          <div className="priceIndicative">
            {this.props.labels.indicativePriceMessage}
          </div>
          }
        </div>
      </div>
    );
  }
}
PriceBreak.propTypes = {
  colSize: PropTypes.number.isRequired,
  energyEfficiencyRating: PropTypes.string.isRequired,
  energyEfficiencyRatingText: PropTypes.string.isRequired,
  energyEfficiencyImage: PropTypes.string.isRequired,
  labels: PropTypes.shape({
    rangeHeaderLabel: PropTypes.string,
    priceHeaderLabel: PropTypes.string,
    indicativePriceHeaderLabel: PropTypes.string,
    indicativePriceMessage: PropTypes.string,
    linePriceHeaderLabel: PropTypes.string,
    wasPriceLabel: PropTypes.string,
    exVatLabel: PropTypes.string,
    vatLabel: PropTypes.string,
    youPayLabel: PropTypes.string,
    energyLabelsProductInformationSheet: PropTypes.string,
    energyLabelsTitle: PropTypes.string,
    energyLabelsCloseButton: PropTypes.string,
  }),
  showIndicativePrices: PropTypes.bool.isRequired,
  priceBreaks: PropTypes.arrayOf(PropTypes.shape({
    priceExVatWithoutCurrencySymbol: PropTypes.string,
    priceIncVatWithoutCurrencySymbol: PropTypes.string,
    priceBreakRange: PropTypes.string,
    priceExVat: PropTypes.string,
    indicativePriceExVat: PropTypes.string,
    incVatAndExVatPriceSameFlag: PropTypes.bool,
    wasPriceExVat: PropTypes.string,
    euEnergyRatingPBJ: PropTypes.string,
  })),
  quantity: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  packSize: PropTypes.number,
  productPrice: PropTypes.shape({
    currencySymDisplayFirst: PropTypes.bool,
    currencyCode: PropTypes.string,
    currencySymbol: PropTypes.string,
    wasPrice: PropTypes.string,
    wasPriceExVat: PropTypes.string,
  }),
  isCustomerSpecificPricing: PropTypes.bool,
  energyProductInfoSheetLink: PropTypes.string,
};

PriceBreak.defaultProps = {
  labels: {},
  priceBreaks: [],
  quantity: 0,
  packSize: 1,
  productPrice: {
    currencySymDisplayFirst: true,
    currencyCode: 'GBP',
    currencySymbol: '£',
    wasPrice: undefined,
    wasPriceExVat: undefined,
  },
  isCustomerSpecificPricing: false,
  energyProductInfoSheetLink: '/',
};




// WEBPACK FOOTER //
// ./src/main/ui/react/product/src/components/PriceBreak/PriceBreak.js